import React from "react";

import { Loader } from "./Spinner.style";

export const Spinner: React.FC<{ size?: number }> = ({ size = 30 }) => (
  <Loader className="spinner" size={size} />
);
